<template>
  <div class="carousel-container bb-px-4" ref="carousel">
    <slot></slot>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';

  @Component
  export default class CarouselWrapper extends Vue {
    scrollToItem(index) {
      this.$nextTick(() => {
        const carousel = this.$refs.carousel;
        const cards = this.$children.map(child => child.$refs.card);

        if (carousel && cards && cards[index]) {
          const card = cards[index];
          const offset =
            card.offsetLeft - carousel.offsetWidth / 2 + card.offsetWidth / 2;
          carousel.scrollTo({ left: offset, behavior: 'smooth' });
        }
      });
    }
  }
</script>

<style scoped lang="scss">
  .carousel-container {
    padding-top: 4px;
    overflow-x: auto;
    display: flex;
    max-width: calc(100vh - 40px);
    scroll-behavior: smooth;
    white-space: nowrap;
    scrollbar-width: none; /* Para Firefox */
  }

  .carousel-container::-webkit-scrollbar {
    display: none; /* Para Chrome, Safari y Opera */
  }

  .carousel {
    display: flex;
    gap: 0px;
  }
</style>
